const en = {
    btnNameSearch: 'Search',
    placeholder: 'Search by advertisements',
    login: 'LogIn',
    registraion: 'SignUp',
    addNewAddBtnName: 'Place an ad',
    city: 'Select City',
    backBtn: 'Back',
      // FilterBtnContainer translations
    priceRangeTitle: 'Select price range',
    resetFilters: 'Reset filters',
    priceFrom: 'from',
    priceTo: 'to',
    selectCity: 'Select city',
    selectCondition: 'Select condition',
    // Main page titles
    searchResultsTitle: 'Ads for query',
    totalAdsTitle: 'Total ads on the site',
    noAdsMessage: 'No ads found',
}

const rus = {
    btnNameSearch: 'Искать',
    placeholder: 'Начните ввод ',
    login: 'Войти',
    registraion: 'Зарегистрироваться', 
    addNewAddBtnName: 'Добавить объявление',
    city: 'Выбрать город',
    backBtn: 'Назад',
      // FilterBtnContainer translations
    priceRangeTitle: 'Выбрать диапазон цен',
    resetFilters: 'Сбросить фильтры',
    priceFrom: 'от',
    priceTo: 'до',
    selectCity: 'Выберите город',
    selectCondition: 'Выбрать состояние',
      // Main page titles
    searchResultsTitle: 'Объявления по запросу',
    totalAdsTitle: 'Количество объявлений на сайте',
    noAdsMessage: 'Объявлений не найдено',
}

const hebrew = {
    btnNameSearch: 'חפש',
    placeholder: 'חפש לפי מודעות',
    login: 'התחברות',
    registraion: 'רישום',
    addNewAddBtnName: 'פרסום מודעה חדשה',
    city: 'עיר',
    backBtn: 'חזרה',
    // FilterBtnContainer translations
    priceRangeTitle: 'בחר טווח מחירים',
    resetFilters: 'אפס מסננים',
    priceFrom: 'מ',
    priceTo: 'עד',
    selectCity: 'בחר עיר',
    selectCondition: 'בחר מצב',
    // Main page titles
    searchResultsTitle: 'מודעות עבור חיפוש',
    totalAdsTitle: 'סה"כ מודעות באתר',
    noAdsMessage: 'לא נמצאו מודעות',

}

const choose = { en, rus, hebrew };

export default choose;